import { useAppSelector } from "../../../store/hooks/hooks";
import { selectRsoClientRequestData } from "../../../store/selectors/rsoClient.selector";
import { ClientRequestData } from "../../../types/clients";

interface ISubmissionView {
  rsoClientRequest: ClientRequestData;
  email: string;
}

const useSubmissionView = (): ISubmissionView => {
  const email = useAppSelector((state) => state.userReducer.user.email);
  const rsoClientRequest = useAppSelector(selectRsoClientRequestData);

  const useRsoRequestClientValues: ISubmissionView = {
    rsoClientRequest: { ...rsoClientRequest },
    email,
  };

  return useRsoRequestClientValues;
};

export default useSubmissionView;
